<template>
  <section class="text-block">
    <b-container
      v-if="servcat.title === $route.query.type"
      v-for="(servcat,index) in servtext"
      :key="index"
    >
      <text100-component
        v-for="(item, index) in servcat.textblocks"
        :key="index"
        v-if="item.type=='text'"
      >
        <wysiwyg-component v-html="item.wysiwyg"></wysiwyg-component>
      </text100-component>

      <img100-component v-else-if="item.img" :img="item.img.url"></img100-component>
    </b-container>
    <b-container v-if="data">
      <template v-for="(item, index) in data">
        <text100-component :key="index" v-if="item.type=='text'">
          <wysiwyg-component v-html="item.wysiwyg"></wysiwyg-component>
        </text100-component>
        <img100-component v-else-if="item.type=='img'" :img="item.img.url" :key="index"></img100-component>
        <div v-else :key="index" class="mb-4">
          <div v-for="(ppl, i) in item.people" :key="i">
            <b-row>
              <b-col cols="12" lg="8" offset-lg="2">
                <p class="ppl-ttl">{{ppl.title}}</p>
              </b-col>
              <b-col
                v-for="(pplR, n) in ppl.people_repeat"
                :key="n"
                cols="12"
                offset-lg="2"
                md="4"
                class="d-flex flex-column justify-content-start align-items-center"
              >
                <div class="img-cont">
                  <img :src="pplR.img.url" alt />
                </div>
                <p class="ppl-fio">{{pplR.text}}</p>
                <p class="ppl-des">{{pplR.text2}}</p>
              </b-col>
            </b-row>
          </div>
        </div>
      </template>
    </b-container>
  </section>
</template>

<script>
const axios = require("axios");
export default {
  props: {
    servtext: Object
  },
  data() {
    return {
      data: null
    };
  },
  beforeMount() {
    if (this.$route.path != "/services/") {
      axios
        .get(`${this.$root.routLink}${this.$route.path}?ajax&act=textblocks`, {
          responseType: "json"
        })
        .then(({ data }) => {
          this.data = JSON.parse(data.addons);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.text-block {
  padding: 0px 0;
  color: $darkColor;
  background-color: $defaultColor;

  @media only screen and (max-width: $xs),
    only screen and (max-device-width: $sm) {
    padding: 0;
  }
  .ppl-ttl {
    font-weight: 500;
    font-size: 30px;
    color: #000000;
    margin-bottom: 15px;
  }
  .img-cont {
    object-fit: cover;
    width: 100%;
    margin-bottom: 15px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .ppl-fio {
    font-weight: 700;
    font-size: 16px;
    line-height: 130%;
    color: #000000;
    margin-bottom: 15px;
  }
  .ppl-des {
    font-size: 14px;
    line-height: 150%;
    color: #000000;
    margin-bottom: 15px;
  }
}
.container {
  padding: 45px 15px;
  @media only screen and (max-width: $md),
    only screen and (max-device-width: $md) {
    padding: 20px 15px;
  }
  @media only screen and (max-width: $xs),
    only screen and (max-device-width: $sm) {
    padding: 40px 15px;
  }
}
</style>